import { Alert, AlertTitle, Box, CircularProgress, Typography, Divider } from "@mui/material";
import { useEffect } from "react";
import { useQuery } from "react-query";
import Grid2 from "@mui/material/Unstable_Grid2"; // Grid version 2
import AllergenDto from "../../models/AllergenDto";
import CustomTitleBox from "../centralComponents/CustomTitleBox";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../provider/LanguageContext";

export default function AllergenPage() {
  const { t } = useTranslation();
  const { language } = useLanguage();

  const { isLoading, error, data, refetch } = useQuery<AllergenDto[], Error>([`/allergens?lang=${language?.language ?? 'de'}`]);

  useEffect(() => {
    refetch();
  }, [language, refetch]);

  return (
    <CustomTitleBox title={t('allergens')}>
      {
        isLoading &&
        <Box textAlign="center" mt={2}>
          <CircularProgress />
        </Box>
      }
      {
        error &&
        <Alert severity="error">
          <>
            <AlertTitle>Fehler</AlertTitle>
            {error.message}
          </>
        </Alert>
      }
      {
        data?.map((allergens) => {
          return (
            <Grid2 container key={allergens.id}>
              <Grid2 xs={1}>
                <Typography>{allergens.name}</Typography>
              </Grid2>
              <Grid2 xs={11}>
                <Typography>{allergens.value}</Typography>
              </Grid2>
            </Grid2>
          );
        })
      }
      <Divider variant="middle" sx={{ mt: '0.8rem', mb: '0.5rem', bgcolor: "darkgrey" }} />
      <Typography style={{ fontSize: '0.6rem' }}>
        {t('allergenInfoEFSA')}
      </Typography>
    </CustomTitleBox>
  );
}
